import * as ConstantRouter from '@/constant/router'

const route = {
  path: '/competitor/:jsId?/register',
  name: ConstantRouter.COMPETITOR_REGISTER,
  component: () => import(/* webpackChunkName: "competitor-register" */ '@/competitor/register')
}

export default route
